import styled from 'styled-components';

/**
 * The clickable text inside a filter chip — the part that reads "is Coffee Habits"
 * and opens the value picker. Shared so a filter whose value editor lives in its
 * own component still renders the same chip as the ones inlined in
 * `FilterConditional`.
 */
export const StyleFilterLabel = styled.div`
    display: inline-block;
    cursor: pointer;
    padding: 4px 0;

    &:hover {
        color: #0a73eb;
    }
`;
